import getUnixTime from 'date-fns/getUnixTime';

/**
 * @return timestamp in seconds
 */
export const getUnixTimestamp = (date: Date = new Date()): number => getUnixTime(date);
export const getUnixTimestampInMilliseconds = (date: Date = new Date()): number => date.valueOf();

export default getUnixTimestamp;
